import axios from "axios";
import request from "../api/request";

// توحيد الأرقام في العرض: أي أرقام هندية (٠-٩) أو فارسية (۰-۹)
// راجعة من السيرفر تُحوَّل تلقائياً إلى غربية (0-9) قبل وصولها للواجهة.
// يُطبَّق على كل استدعاءات axios (الافتراضية + نسخة request).

const HINDI_RE = /[٠-٩۰-۹]/g;
const DIGIT_MAP = {
  "٠": "0", "١": "1", "٢": "2", "٣": "3", "٤": "4",
  "٥": "5", "٦": "6", "٧": "7", "٨": "8", "٩": "9",
  "۰": "0", "۱": "1", "۲": "2", "۳": "3", "۴": "4",
  "۵": "5", "۶": "6", "۷": "7", "۸": "8", "۹": "9",
};

function toWestern(value) {
  if (typeof value === "string") {
    return HINDI_RE.test(value)
      ? value.replace(HINDI_RE, (d) => DIGIT_MAP[d])
      : value;
  }
  if (Array.isArray(value)) {
    for (let i = 0; i < value.length; i++) value[i] = toWestern(value[i]);
    return value;
  }
  if (value && typeof value === "object") {
    for (const k of Object.keys(value)) value[k] = toWestern(value[k]);
    return value;
  }
  return value;
}

function attach(instance) {
  instance.interceptors.response.use(
    (response) => {
      if (response && response.data !== undefined) {
        response.data = toWestern(response.data);
      }
      return response;
    },
    (error) => Promise.reject(error)
  );
}

export function setupDigitNormalization() {
  attach(axios);
  attach(request);
}
